import { ReferralContent } from './ReferralContent';
import { ReferralMedia } from './ReferralMedia';
import { Schema } from './Referral.schema';

export function Referral({ cms }) {
  const { section, content, media } = cms;
  const {
    aspectDesktop,
    aspectMobile,
    aspectTablet,
    fill,
    mediaOrderDesktop,
    mediaOrderMobile,
  } = {
    ...media,
  };

  const maxWidthContainerClass = section?.fullWidth
    ? 'max-w-none'
    : 'max-w-[var(--content-max-lg-width)]';
  const fillClass = fill
    ? 'h-full'
    : `md:before:float-left ${aspectTablet} ${aspectDesktop}`;
  const mediaOrderClasses = `${
    mediaOrderMobile === '2' ? 'order-2' : 'order-1'
  } ${mediaOrderDesktop === '2' ? 'md:order-2' : 'md:order-1'}`;
  const contentOrderClasses = `${
    mediaOrderMobile === '2' ? 'order-1' : 'order-2'
  } ${mediaOrderDesktop === '2' ? 'md:order-1' : 'md:order-2'}`;
  const mediaBgColorClass =
    section?.bgColor === 'var(--background)' ||
    section?.bgColor === 'var(--white)'
      ? 'bg-offWhite'
      : '';
  const firstButton = Array.isArray(content?.buttons) && content.buttons.length > 0 ? content.buttons[0]?.link : null;

  return (
    <div
      className={`${section?.fullBleed ? '' : 'px-contained'} ${
        section?.verticalPadding ? 'py-contained' : ''
      }`}
      style={{ backgroundColor: section?.bgColor }}
    >
      <div
        className={`relative mx-auto grid grid-cols-1 items-center md:grid-cols-2 ${maxWidthContainerClass}`}
      >
        <div
          className={`relative w-full max-md:before:float-left ${aspectMobile} ${fillClass} ${mediaOrderClasses} ${mediaBgColorClass}`}
        >
          <ReferralMedia
            aboveTheFold={section?.aboveTheFold}
            media={media}
            videoAlt={content?.heading}
            firstButton={firstButton}
          />
        </div>

        <div
          className={`flex w-full items-center md:before:float-left ${aspectTablet} ${aspectDesktop} ${contentOrderClasses}`}
        >
          <ReferralContent
            aboveTheFold={section?.aboveTheFold}
            content={content}
          />
        </div>
      </div>
    </div>
  );
}

Referral.displayName = 'Referral';
Referral.Schema = Schema;
